// product-variant-thumbs.js

(function() {
  'use strict';

  // 在DOM加载完成后初始化组件
  document.addEventListener('DOMContentLoaded', function() {
    PVT_k4e_initVariantThumbs();
  });

  /**
   * 初始化变体略缩图组件
   */
  function PVT_k4e_initVariantThumbs() {
    // 获取变体略缩图容器
    const pvt_k4e_variantThumbsContainers = document.querySelectorAll('[data-pvt-variant-thumbs]');
    
    if (!pvt_k4e_variantThumbsContainers.length) return;
    
    pvt_k4e_variantThumbsContainers.forEach(function(pvt_k4e_container) {
      // 获取该容器内的所有略缩图项
      const pvt_k4e_variantThumbItems = pvt_k4e_container.querySelectorAll('.pvt_k4e_product__thumb-item--variant');
      
      if (!pvt_k4e_variantThumbItems.length) return;
      
      // 为每个略缩图添加鼠标悬停和点击效果
      pvt_k4e_variantThumbItems.forEach(function(pvt_k4e_item) {
        // 鼠标悬停效果
        pvt_k4e_item.addEventListener('mouseover', function() {
          if (this.style.borderColor !== 'rgb(11, 94, 62)') { // 不是当前选中的
            this.style.borderColor = '#999';
          }
        });
        
        pvt_k4e_item.addEventListener('mouseout', function() {
          if (this.style.borderColor !== 'rgb(11, 94, 62)') { // 不是当前选中的
            this.style.borderColor = '#ddd';
          }
        });
        
        // 点击事件
        pvt_k4e_item.addEventListener('click', function(e) {
          e.preventDefault();
          
          // 获取变体ID
          const pvt_k4e_variantId = this.getAttribute('data-pvt-variant-id');
          if (!pvt_k4e_variantId) return;
          
          // 查找对应的变体选择器并触发更改
          // 1. 找到变体JSON数据
          const pvt_k4e_variantJson = document.querySelector('[data-pvt-variant-json]');
          if (!pvt_k4e_variantJson) {
            console.error('找不到变体JSON数据');
            return;
          }
          
          // 2. 解析变体数据
          let pvt_k4e_variants;
          try {
            pvt_k4e_variants = JSON.parse(pvt_k4e_variantJson.textContent);
          } catch (error) {
            console.error('变体JSON解析错误:', error);
            return;
          }
          
          if (!pvt_k4e_variants || !pvt_k4e_variants.length) {
            console.error('变体数据为空');
            return;
          }
          
          // 3. 找到对应的变体
          let pvt_k4e_selectedVariant = null;
          for (let i = 0; i < pvt_k4e_variants.length; i++) {
            if (pvt_k4e_variants[i].id == pvt_k4e_variantId) {
              pvt_k4e_selectedVariant = pvt_k4e_variants[i];
              break;
            }
          }
          
          if (!pvt_k4e_selectedVariant) {
            console.error('找不到对应变体:', pvt_k4e_variantId);
            return;
          }
          
          // 4. 设置变体选项
          const pvt_k4e_optionSelectors = document.querySelectorAll('[data-variant-input]');
          if (!pvt_k4e_optionSelectors.length) {
            console.error('找不到变体选择器');
            return;
          }
          
          // 按选项索引分组
          const pvt_k4e_selectorsByIndex = {};
          pvt_k4e_optionSelectors.forEach(function(pvt_k4e_selector) {
            const pvt_k4e_index = pvt_k4e_selector.getAttribute('data-index');
            if (!pvt_k4e_selectorsByIndex[pvt_k4e_index]) {
              pvt_k4e_selectorsByIndex[pvt_k4e_index] = [];
            }
            pvt_k4e_selectorsByIndex[pvt_k4e_index].push(pvt_k4e_selector);
          });
          
          // 5. 为每个选项设置正确的值
          for (const pvt_k4e_index in pvt_k4e_selectorsByIndex) {
            if (!pvt_k4e_selectorsByIndex.hasOwnProperty(pvt_k4e_index)) continue;
            
            const pvt_k4e_optionIndex = parseInt(pvt_k4e_index) + 1;
            const pvt_k4e_optionValue = pvt_k4e_selectedVariant['option' + pvt_k4e_optionIndex];
            const pvt_k4e_selectors = pvt_k4e_selectorsByIndex[pvt_k4e_index];
            
            // 找到匹配值的选择器
            let pvt_k4e_found = false;
            for (let j = 0; j < pvt_k4e_selectors.length; j++) {
              const pvt_k4e_selector = pvt_k4e_selectors[j];
              const pvt_k4e_value = pvt_k4e_selector.value;
              
              if (pvt_k4e_value === pvt_k4e_optionValue) {
                pvt_k4e_found = true;
                
                // 如果是单选按钮或复选框
                if (pvt_k4e_selector.type === 'radio' || pvt_k4e_selector.type === 'checkbox') {
                  pvt_k4e_selector.checked = true;
                } else {
                  pvt_k4e_selector.selected = true;
                }
                
                // 触发变更事件
                const pvt_k4e_event = new Event('change', { bubbles: true });
                pvt_k4e_selector.dispatchEvent(pvt_k4e_event);
                break;
              }
            }
            
            if (!pvt_k4e_found) {
              console.error('未找到匹配 ' + pvt_k4e_optionValue + ' 的选择器');
            }
          }
          
          // 6. 高亮显示当前选中的略缩图
          pvt_k4e_variantThumbItems.forEach(function(pvt_k4e_thumbItem) {
            pvt_k4e_thumbItem.style.borderColor = '#ddd';
            pvt_k4e_thumbItem.style.borderWidth = '1px';
            pvt_k4e_thumbItem.classList.remove('pvt_k4e_active');
          });
          
          this.style.borderColor = '#0b5e3e';
          this.style.borderWidth = '2px';
          this.classList.add('pvt_k4e_active');
        });
      });
      
      // 初始化时高亮显示当前变体的略缩图
      const pvt_k4e_currentVariantJson = document.querySelector('[data-pvt-current-variant-json]');
      if (pvt_k4e_currentVariantJson) {
        try {
          const pvt_k4e_currentVariant = JSON.parse(pvt_k4e_currentVariantJson.textContent);
          
          if (pvt_k4e_currentVariant && pvt_k4e_currentVariant.id) {
            const pvt_k4e_currentThumb = pvt_k4e_container.querySelector('[data-pvt-variant-id="' + pvt_k4e_currentVariant.id + '"]');
            if (pvt_k4e_currentThumb) {
              pvt_k4e_currentThumb.style.borderColor = '#0b5e3e';
              pvt_k4e_currentThumb.style.borderWidth = '2px';
              pvt_k4e_currentThumb.classList.add('pvt_k4e_active');
            }
          }
        } catch(e) {
          console.error('解析当前变体JSON出错:', e);
        }
      }
    });
    
    // 监听变体变化事件，更新变体略缩图高亮状态
    document.addEventListener('variant:change', function(event) {
      if (!event.detail || !event.detail.variant) return;
      
      const pvt_k4e_variantId = event.detail.variant.id;
      const pvt_k4e_variantThumbs = document.querySelector('[data-pvt-variant-thumbs]');
      
      if (!pvt_k4e_variantThumbs) return;
      
      const pvt_k4e_thumbItems = pvt_k4e_variantThumbs.querySelectorAll('.pvt_k4e_product__thumb-item--variant');
      
      let pvt_k4e_found = false;
      pvt_k4e_thumbItems.forEach(function(pvt_k4e_thumbItem) {
        const pvt_k4e_itemVariantId = pvt_k4e_thumbItem.getAttribute('data-pvt-variant-id');
        
        if (pvt_k4e_itemVariantId == pvt_k4e_variantId) {
          pvt_k4e_found = true;
          pvt_k4e_thumbItem.style.borderColor = '#0b5e3e';
          pvt_k4e_thumbItem.style.borderWidth = '2px';
          pvt_k4e_thumbItem.classList.add('pvt_k4e_active');
        } else {
          pvt_k4e_thumbItem.style.borderColor = '#ddd';
          pvt_k4e_thumbItem.style.borderWidth = '1px';
          pvt_k4e_thumbItem.classList.remove('pvt_k4e_active');
        }
      });
    });
  }
})(); 